module.exports = __webpack_public_path__ + "img/icon_xing.e0241e98d924e8f0f2a09641602f9970.svg";